import { render, staticRenderFns } from "./ChangeOrderEmail.vue?vue&type=template&id=40c5fcdb&scoped=true&"
import script from "./ChangeOrderEmail.vue?vue&type=script&lang=js&"
export * from "./ChangeOrderEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c5fcdb",
  null
  
)

export default component.exports